import { Date, DateService, DateTimeUtils } from '@mews/framework';

interface IsDateInPastParams {
    currentDate: Date;
    dateTimeUtc: string;
    timezone: string;
}

export const isDateInPast = ({ currentDate, dateTimeUtc, timezone }: IsDateInPastParams) => {
    const date = DateTimeUtils.dateTimeUtcStringToDate(dateTimeUtc, timezone);

    return DateService.isLess(date, currentDate);
};
